import { render, staticRenderFns } from "./withdrawalRecords.vue?vue&type=template&id=31a05f9e&scoped=true&"
import script from "./withdrawalRecords.vue?vue&type=script&lang=js&"
export * from "./withdrawalRecords.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalRecords.vue?vue&type=style&index=0&id=31a05f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a05f9e",
  null
  
)

export default component.exports